export default __webpack_public_path__ + "static/media/fornitori.14b3fc74.pdf";